import { cn } from "../../../../lib/utils";

const PRESETS = [
  { value: "24h", label: "24H" },
  { value: "7d", label: "7D" },
  { value: "30d", label: "30D" },
  { value: "all", label: "ALL" },
];

export function WindowPicker({ preset, onChange }) {
  return (
    <div className="inline-flex items-center rounded-md border border-border bg-base-9/70 p-0.5">
      {PRESETS.map((p) => {
        const active = p.value === preset;
        return (
          <button
            key={p.value}
            type="button"
            onClick={() => onChange(p.value)}
            className={cn(
              "relative h-7 min-w-[44px] rounded-[5px] px-2.5 font-mono text-xs font-medium tracking-wider transition-colors",
              active
                ? "bg-white/[0.08] text-foreground shadow-[inset_0_0_0_1px_rgba(10,196,136,0.3)]"
                : "text-muted-foreground hover:bg-white/[0.05] hover:text-foreground",
            )}
          >
            {/* Green selector line - top */}
              {/* {active && (
                <span
                  className="absolute left-1/2 top-0 h-1 w-8 -translate-x-1/2 rounded-b-sm bg-ginox-green"
                  aria-hidden="true"
                />
              )} */}
            {p.label}
          </button>
        );
      })}
    </div>
  );
}
